












































import { mixins } from 'vue-class-component'
import { Component, Prop } from 'vue-property-decorator'

import DisalableBookingElementMixin from '@/components/DisalableBookingElementMixin.vue'

import Booking from '@/models/booking'

import dayjs, { Dayjs } from '@/dayjs'
import { UtilityGetters } from '@/store/modules/utility'

@Component
export default class BookingQuickLinks extends mixins(
  DisalableBookingElementMixin,
) {
  @Prop() booking!: Booking
  @Prop() showVisaLetter!: boolean
  @Prop() showPreDepartureInfo!: boolean
  @Prop() showFacebookGroup!: boolean
  @Prop() hasPassengerAccess!: boolean

  get showQuickLinks(): boolean {
    return (
      this.showPreDepartureInfo ||
      this.showVisaLetter ||
      this.showItinerary ||
      this.showFacebookGroup ||
      this.showFloatistAuthUrl ||
      this.showProvisioningLink ||
      this.showGuideUrl
    )
  }

  get showItinerary(): boolean {
    return this.booking?.direction?.itinerary?.length > 0
  }

  get showFAQs(): boolean {
    return this.booking?.direction?.faqs?.length > 0
  }

  get showFloatistAuthUrl(): boolean {
    return (
      this.booking?.floatistAuthUrl?.length > 0 &&
      this.currentDate.isAfter(dayjs(this.booking.departAt))
    )
  }

  get showProvisioningLink(): boolean {
    return this.booking?.isYachtCharter && !!this.booking?.provisioningLink
  }

  get showGuideUrl(): boolean {
    return (
      this.hasPassengerAccess &&
      !this.booking?.isYachtCharter &&
      !!this.booking?.guideUrl
    )
  }

  get itineraryLink(): string {
    return this.booking?.direction?.itinerary
  }

  get FAQsLink(): string {
    return this.booking?.direction?.faqs
  }

  get preDepartureInfoLink(): string {
    return (
      this.booking &&
      this.booking.direction &&
      this.booking.direction.preDepartureInfo
    )
  }

  get facebookGroupLink(): string {
    return (
      this.booking &&
      this.booking.direction &&
      this.booking.direction.facebookGroup
    )
  }

  get currentDate(): Dayjs {
    return this.$store.getters[UtilityGetters.CurrentDate] || dayjs.utc()
  }
}
